<div class="badge">{{ displayCount ? count : '' }}</div>
